import lazyScreen from '../utils/lazyScreen';
const AccountingPending = lazyScreen(() => import('../pages/acc/AccountingPending/index.js'), 'pages/acc/AccountingPending/index.js');
const AccountingOptions = lazyScreen(() => import('../pages/acc/AccountingOptions/index.js'), 'pages/acc/AccountingOptions/index.js');
// Đợt 5: Khởi tạo bộ sổ (TL-01).
const BookSetup = lazyScreen(() => import('../pages/acc/BookSetup/index.js'), 'pages/acc/BookSetup/index.js');
// Đợt 5: Loại tài sản (DM-11).
const AssetCategories = lazyScreen(() => import('../pages/acc/AssetCategories/index.js'), 'pages/acc/AssetCategories/index.js');
// Đợt 4: báo cáo chỉ đọc của chế độ Kế toán.
const AssetReports = lazyScreen(() => import('../pages/acc/AssetReports/index.js'), 'pages/acc/AssetReports/index.js');
const PayrollReports = lazyScreen(() => import('../pages/acc/PayrollReports/index.js'), 'pages/acc/PayrollReports/index.js');
const Receivables = lazyScreen(() => import('../pages/acc/Receivables/index.js'), 'pages/acc/Receivables/index.js');
const Payables = lazyScreen(() => import('../pages/acc/Payables/index.js'), 'pages/acc/Payables/index.js');
const CashForecast = lazyScreen(() => import('../pages/acc/CashForecast/index.js'), 'pages/acc/CashForecast/index.js');
const SalesReports = lazyScreen(() => import('../pages/acc/SalesReports/index.js'), 'pages/acc/SalesReports/index.js');
const PurchaseReports = lazyScreen(() => import('../pages/acc/PurchaseReports/index.js'), 'pages/acc/PurchaseReports/index.js');
const StockLedger = lazyScreen(() => import('../pages/acc/StockLedger/index.js'), 'pages/acc/StockLedger/index.js');
const CostingReports = lazyScreen(() => import('../pages/acc/CostingReports/index.js'), 'pages/acc/CostingReports/index.js');
const Reconciliation = lazyScreen(() => import('../pages/acc/Reconciliation/index.js'), 'pages/acc/Reconciliation/index.js');
const BulkExport = lazyScreen(() => import('../pages/acc/BulkExport/index.js'), 'pages/acc/BulkExport/index.js');

export default [
    { path: '/acc/pending/:code', component: AccountingPending },
    { path: '/acc/options', component: AccountingOptions },
    { path: '/acc/book-setup', component: BookSetup },
    { path: '/acc/asset-categories', component: AssetCategories },
    { path: '/acc/asset-reports', component: AssetReports },
    { path: '/acc/payroll-reports', component: PayrollReports },
    { path: '/acc/receivables', component: Receivables },
    { path: '/acc/payables', component: Payables },
    { path: '/acc/cash-forecast', component: CashForecast },
    { path: '/acc/sales-reports', component: SalesReports },
    { path: '/acc/purchase-reports', component: PurchaseReports },
    { path: '/acc/stock-ledger', component: StockLedger },
    { path: '/acc/costing-reports', component: CostingReports },
    { path: '/acc/reconciliation', component: Reconciliation },
    { path: '/acc/bulk-export', component: BulkExport }
];
